module.exports = __webpack_public_path__ + "static/media/27-min.fe2eb1db.jpg";